<template>
  <div id="contenedor-agregar-contrato-tema">
    <v-card>
      <v-card-title class="secondary--text">
        Agregar Tema
        <v-spacer></v-spacer>
        <v-btn icon @click="cerrar">
          <v-icon class="secondary--text" large>highlight_off</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider class="mx-2"></v-divider>
      <v-card-text>
        <v-form v-model="formularioValido" ref="registrarContratoTema">
          <v-row>
            <v-col cols="12">
              <TextField v-model="tema.clave" label="Clave" :rules="[mixReglas.requerido]">
              </TextField>
            </v-col>
            <v-col cols="12">
              <TextArea
                v-model="tema.descripcion"
                label="Descripción"
                rows="2"
                :rules="[mixReglas.requerido]"
              >
              </TextArea>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-divider class="bkground" />
      <v-card-actions>
        <v-spacer></v-spacer>
        <custom-button @click="cerrar" tipo="formCancelar" label="Cancelar" class="mr-3">
        </custom-button>
        <custom-button
          @click="mixAgergarTema"
          :disabled="!formularioValido || enviandoFormulario"
          :loading="enviandoFormulario"
          tipo="formAceptar"
          label="Guardar"
        >
        </custom-button>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import TextField from '@/components/inputs/sinColumnas/TextField.vue';
import TextArea from '@/components/inputs/sinColumnas/TextArea.vue';
import CustomButton from '@/components/buttons/Button.vue';
import mixTemasContrato from './mixTemasContrato';

export default {
  name: 'AgregarContratoTema',
  mixins: [mixTemasContrato],
  components: {
    TextArea,
    TextField,
    CustomButton,
  },
  props: {
    idContrato: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      formularioValido: false,
      enviandoFormulario: false,
      tema: {
        idContrato: this.idContrato,
        clave: null,
        descripcion: null,
      },
    };
  },
  methods: {
    cerrar() {
      this.$refs.registrarContratoTema.reset();
      this.$emit('cerrar');
    },
  },
};
</script>

<style lang="scss"></style>
